import { createContext } from 'react';
import { Business, BusinessLocation, BusinessLocationPreferredWorker, ShiftProviderUser } from 'models';

interface IPreferredWorkerModalContext {
    isAdmin: boolean;
    business: Business | { id: number; name: string };
    provider: ShiftProviderUser;
    emptyLocationList: boolean;
    locations: BusinessLocationPreferredWorker[];
    businessLocation?: BusinessLocation;
    setLocations: React.Dispatch<React.SetStateAction<BusinessLocationPreferredWorker[]>>;
    setError: React.Dispatch<React.SetStateAction<boolean>>;
    onSuccess: (preferredWorkers: BusinessLocationPreferredWorker[]) => void;
    onClose: () => void;
}

export const PreferredWorkerModalContext = createContext<IPreferredWorkerModalContext>({
    isAdmin: false,
    business: {} as Business,
    provider: {} as ShiftProviderUser,
    emptyLocationList: false,
    locations: [],
    businessLocation: {} as BusinessLocation,
    setLocations: () => {},
    setError: () => {},
    onSuccess: () => {},
    onClose: () => {},
});
